import React from 'react';
import PropTypes from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import config from '~/Config';
import Button from '~/Components/Global/Form/Button';
import Spinner from '~/Components/Global/Loading/Spinner';
import SetupIntentForm from '~/Components/Pages/Subscription/SetupIntentForm';
import SubscriptionPlan from './SubscriptionPlan';

import './ManageSubscription.scss';

const stripePromise = loadStripe(config.stripeKey, config.stripeOptions);

const SwapToStripe = ({
  setupIntent,
  setupIntentError,
  setSetupIntentId,
  selectedPlan,
  isFetching,
  account,
  coupon,
  handleFieldChanged,
  postalCode,
  handleSave,
  errorMessage,
  eventId,
  pricingPlans,
  historicalPlans,
  onPlanSelect,
}) => {
  const renderErrorMessage = () => {
    return (
      <>
        <div className="error-message">{errorMessage}</div>
      </>
    );
  };

  const renderSaveButton = () => (
    <Button
      type="button"
      text="SAVE"
      className="pill"
      onClick={handleSave}
      isFetching={isFetching}
      actionText="SAVING"
    />
  );

  const renderPlans = () => {
    return [...historicalPlans, 'yearly', 'yearlyPlus'].map(planKey => {
      const plan = pricingPlans[planKey];
      return (
        <SubscriptionPlan
          key={planKey}
          plan={plan}
          isSelected={plan === selectedPlan}
          onClick={() => onPlanSelect(plan)}
          displayName={plan.displayName}
          price={plan.price}
          billingCycle={plan.billingCycle}
        />
      );
    });
  };

  return (
    <div className="swap-to-stripe">
      {renderPlans()}
      {setupIntent && selectedPlan && (
        <Elements
          stripe={stripePromise}
          options={{
            clientSecret: setupIntent.clientSecret,
            appearance: { variables: { fontSizeBase: '14px' } },
            loader: 'always',
          }}
          key={setupIntent.clientSecret}
        >
          <SetupIntentForm
            isFetching={isFetching}
            user={account}
            intent={setupIntent}
            setSetupIntentId={setSetupIntentId}
            amount={selectedPlan.price}
            plan={selectedPlan.plan}
            showCoupon
            coupon={coupon}
            updateField={handleFieldChanged}
            postalCode={postalCode}
          />
        </Elements>
      )}
      {setupIntentError && (
        <div className="text-danger">
          An error occurred while setting up payments. Please try again later.
        </div>
      )}
      {!setupIntent && !setupIntentError && <Spinner />}
      <input id="artfulUserId" type="hidden" name="userId" value={account.id} />
      <input id="artfulEventId" type="hidden" name="eventId" value={eventId} />

      {errorMessage && renderErrorMessage()}

      <div className="actions">{renderSaveButton()}</div>
    </div>
  );
};

SwapToStripe.propTypes = {
  setupIntent: PropTypes.object,
  setupIntentError: PropTypes.object,
  setSetupIntentId: PropTypes.func,
  selectedPlan: PropTypes.object,
  isFetching: PropTypes.bool,
  account: PropTypes.object,
  coupon: PropTypes.string,
  handleFieldChanged: PropTypes.func,
  postalCode: PropTypes.string,
  handleSave: PropTypes.func,
  errorMessage: PropTypes.string,
  eventId: PropTypes.string,
  pricingPlans: PropTypes.object.isRequired,
  historicalPlans: PropTypes.array.isRequired,
  onPlanSelect: PropTypes.func.isRequired,
};

export default SwapToStripe;
